import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useDownloadBulkReceipts = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (ids) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/consultationpayment/receipt/getbyids`,
        ids,
        { responseType: "blob" }
      );
      return response.data;
    },
  });
};
